<template>
  <div class=" col-lg-10 col-md-11 col-sm-12 m-auto">
    <div class="jipvio-contract contract">
      <img src="/../img/contract1.jpg" />

      <!-- line1 (매도, 매수, 임대, 임차 등 체크) -->

      <div class="con-line" id="con1-line1">
        <div class="con-line-div" id="con1-line1-div1">
          <input type="checkbox" disabled="disabled" class="con-line-input" />
        </div>
        <div class="con-line-div" id="con1-line1-div2">
          <input type="checkbox" disabled="disabled" class="con-line-input" />
        </div>
        <div class="con-line-div" id="con1-line1-div3">
          <ValidationProvider
            ref="leaseCheckVal"
            vid="leaseCheckVal"
            rules="required|true"
          >
            <input
              ref="leaseCheckBox"
              type="checkbox"
              class="con-line-input"
              v-model="leaseCheck"
            />
          </ValidationProvider>
        </div>
        <div class="con-line-div" id="con1-line1-div4">
          <input type="checkbox" disabled="disabled" class="con-line-input" />
        </div>
        <div class="con-line-div" id="con1-line1-div5">
          <input type="checkbox" disabled="disabled" class="con-line-input" />
        </div>
        <div class="con-line-div" id="con1-line1-div6">
          <input disabled="disabled" class="con-line-input" />
        </div>
      </div>

      <!-- line2 (공개 또는 비공개 여부) -->
      <div class="con-line" id="con1-line2">
        <div class="con-line-div" id="con1-line2-div1">
          <span id="con1-line2-div1-p1">{{ provideDataLiteral }}</span>
        </div>
        <div class="con-line-div" id="con1-line2-div2">
          <ValidationProvider
            ref="provideDataVal"
            vid="provideDataVal"
            rules="required|isOne"
          >
            <select
              ref="provideDataSelect"
              id="con1-line2-div2-select1"
              v-model="provideData"
            >
              <option value="1">공개</option>
              <option value="0">비공개</option>
            </select>
          </ValidationProvider>
        </div>
        <el-tooltip
          class="item"
          effect="dark"
          content="공개 선택시, 매물 노출 및 광고 서비스 제공"
          placement="top"
        >
          <div class="contract-tooltip" id="con1-line2-div3-info">
            <p class="contract-info">
              <!--Sohyun-->
              <i class="fas fa-exclamation-circle"></i>
            </p>
          </div>
        </el-tooltip>
        <!--<div id="divinput1Info">
              <i class="fas fa-exclamation-circle" style="color: #797979"></i>
              공개를 선택하시면, 매물 노출 및 광고 서비스를 받으실 수 있습니다.
            </div>-->
      </div>

      <!-- line3 (계약의 유효기간) -->
      <div class="con-line" id="con1-line3">
        <div class="con-line-div" id="con1-line3-div1">
          <input v-model="contrValDay.year" class="con-line-input" disabled />
        </div>
        <div class="con-line-div" id="con1-line3-div2">
          <input v-model="contrValDay.month" class="con-line-input" disabled />
        </div>
        <div class="con-line-div" id="con1-line3-div3">
          <input v-model="contrValDay.date" class="con-line-input" disabled />
        </div>
        <el-tooltip
          class="item"
          effect="dark"
          content="계약서 작성일로부터 3개월 자동 계산"
          placement="top"
        >
          <div class="contract-tooltip" id="con1-line3-div4-info">
            <p class="contract-info">
              <i class="fas fa-exclamation-circle"></i>
            </p>
          </div>
        </el-tooltip>
      </div>

      <!-- line4 (중개보수) -->
      <div class="con-line" id="con1-line4">
        <div class="con-line-div" id="con1-line4-div1">
          <fg-input v-model="brokCompenRate" class="con-line-input" readonly />
        </div>
        <div class="con-line-div" id="con1-line4-div2">
          <fg-input v-model="brokCompenPrice" class="con-line-input" readonly />
        </div>
        <el-tooltip
          class="item"
          effect="dark"
          content="서울특별시 부동산 중개보수 요율표에 따라 자동 입력"
          placement="top-end"
        >
          <div class="contract-tooltip" id="con1-line4-div3-info">
            <p class="contract-info">
              <i class="fas fa-exclamation-circle"></i>
            </p>
          </div>
        </el-tooltip>
      </div>

      <!-- line5 (계약서 작성일) -->
      <div class="con-line" id="con1-line5">
        <div class="con-line-div" id="con1-line5-div1">
          <input v-model="today.year" class="con-line-input" disabled />
        </div>
        <div class="con-line-div" id="con1-line5-div2">
          <input v-model="today.month" class="con-line-input" disabled />
        </div>
        <div class="con-line-div" id="con1-line5-div3">
          <input v-model="today.date" class="con-line-input" disabled />
        </div>
      </div>

      <!-- line6 (중개의뢰인 주소, 성명) -->
      <div class="con-line" id="con1-line6">
        <div class="con-line-div" id="con1-line6-div1">
          <input v-model="ownerFullAddr" class="con1-line6-input" disabled />
        </div>
        <div class="con-line-div" id="con1-line6-div2">
          <input
            v-model="certification.ownerName"
            class="con1-line6-input"
            disabled
          />
        </div>
        <div class="con-line-div" id="con1-line6-div3">
          <el-upload
            :auto-upload="false"
            action="#"
            :limit="1"
            class="upload-demo"
            :on-change="uploadChange"
            :on-remove="removeFile"
            :on-exceed="exceedFileLimit"
            :show-file-list="true"
            :file-list="G_Img_File.fileList"
            list-type="picture"
          >
            <input id="con1-line6-sign" type="button" value="서명 업로드" />
          </el-upload>
          <!-- <input
                ref="imageInput"
                type="file"
                hidden
                @change="onChangeImages"
              />
              <input
                id="con1-line6-sign"
                type="button"
                value="서명 업로드"
                @click="onClickImageUpload"
              /> -->
        </div>
        <!-- <div class="con-line-div" id="con1-line6-div4">
              <img id="con1-line6-div4-img1" v-if="imageUrl" :src="imageUrl" />
            </div> -->
      </div>

      <!-- line7 (중개의뢰인 생년월일, 전화번호) -->
      <div class="con-line" id="con1-line7">
        <div class="con-line-div" id="con1-line7-div1">
          <input v-model="clientBirth" class="con-line-input" />
        </div>
        <div class="con-line-div" id="con1-line7-div2">
          <input
            v-model="certification.ownerTel"
            class="con-line-input"
            disabled
          />
        </div>
      </div>

      <!-- line8 (공인중개사 주소, 성명) -->
      <div class="con-line" id="con1-line8">
        <div class="con-line-div" id="con1-line8-div1">
          <input v-model="brokerAddr" class="con1-line8-input" disabled />
        </div>
        <div class="con-line-div" id="con1-line8-div2">
          <input v-model="brokerName" class="con1-line8-input" disabled />
        </div>
      </div>

      <!-- line9 (공인중개사 상호, 등록번호) -->
      <div class="con-line" id="con1-line9">
        <div class="con-line-div" id="con1-line9-div1">
          <input v-model="companyName" class="con-line-input" disabled />
        </div>
        <div class="con-line-div" id="con1-line9-div2">
          <input v-model="brokerResNum" class="con-line-input" disabled />
        </div>
      </div>

      <!-- line10 (공인중개사 생년월일, 전화번호) -->
      <div class="con-line" id="con1-line10">
        <div class="con-line-div" id="con1-line10-div1">
          <input v-model="brokerBirth" class="con-line-input" disabled />
        </div>
        <div class="con-line-div" id="con1-line10-div2">
          <input v-model="brokerTel" class="con-line-input" disabled />
        </div>
      </div>

      <!-- line11 다음 버튼 -->
      <div class="con-line" id="con1-line11">
        <div class="con-line-div" id="con1-line11-div1">
          <el-button class="btn" id="con1-line11-nextButton" @click="ToPage2">
            다음페이지
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Button, Tooltip, Upload, Checkbox, Message } from "element-ui";
import { createNamespacedHelpers, mapGetters } from "vuex";

const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    [Row.name]: Row,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Upload.name]: Upload,
    [Checkbox.name]: Checkbox,
    [Message.name]: Message
  },

  data() {
    return {
      G_Img_File: {
        data: null, // request body
        fileList: [],
        idArr: [],
        removedIdArr: []
      },
      //contract 1
      leaseCheck: null, //임대 체크

      provideData: null, //정보 공개여부

      brokCompenRate: null, //중개보수 거래가액의 %
      brokCompenPrice: null, //중개보수 가격 (원)

      clientAddr: null, // 중개의뢰인 주소
      clientName: null, // 중개의뢰인 성명
      clientBirth: null, // 중개의뢰인 생년월일
      clientTel: null, // 중개의뢰인 전화번호

      brokerAddr: "서울시 구로구 고척로 89, 1층 일부", //공인중개사 주소
      brokerName: "유소현", //공인중개사 이름
      companyName: "집비오부동산중개", //상호(명칭)
      brokerResNum: "제11530-2020-00050호", //공인중개서 등록번호
      brokerBirth: "1991년 05월 17일", //공인중개사 생년월일
      brokerTel: "02-2688-3244 / 010-4968-4919", //공인중개사 전화번호

      imageUrl: null //서명 파일Url
    };
  },

  created() {
    this.bringData();
  },

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    }),
    provideDataLiteral() {
      if (this.provideData == "1") {
        return "공개";
      } else if (this.provideData == "0") {
        return "비공개";
      } else {
        return null;
      }
    },
    certification() {
      return this.sessionPropertyInquiry.certification;
    },

    ownerFullAddr() {
      return (
        this.sessionPropertyInquiry.certification.ownerAddr +
        " " +
        this.sessionPropertyInquiry.certification.ownerAddrDetail
      );
    },
    today() {
      let today = new Date();
      return {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate()
      };
    },
    contrValDay() {
      let cvDay = new Date();
      cvDay.setMonth(cvDay.getMonth() + 3);
      cvDay.setDate(cvDay.getDate() - 1);
      // let contrvUTC = new Date(
      //   cvDay.getTime() + cvDay.getTimezoneOffset() * 60000
      // );

      const contrvUTC = this.$moment(contrvUTC).format("YYYY-MM-DD HH:mm:ss");

      return {
        cvUTC: contrvUTC,
        year: cvDay.getFullYear(),
        month: cvDay.getMonth() + 1,
        date: cvDay.getDate()
      };
    }
  },

  methods: {
    bringData() {
      //contract 1
      this.leaseCheck = this.sessionPropertyInquiry.contractInfo.p1LeaseCheck; //임대 체크

      if (this.sessionPropertyInquiry.contractInfo.provideData !== null) {
        this.provideData = Number(
          this.sessionPropertyInquiry.contractInfo.provideData
        ).toString(); //정보 공개여부
      }

      this.clientAddr = this.sessionPropertyInquiry.contractInfo.clientAddr; // 중개의뢰인 주소
      this.clientName = this.sessionPropertyInquiry.contractInfo.clientName; // 중개의뢰인 성명
      this.clientBirth = this.sessionPropertyInquiry.contractInfo.clientBirth; // 중개의뢰인 생년월일
      this.clientTel = this.sessionPropertyInquiry.contractInfo.clientTel; // 중개의뢰인 전화번호

      this.imageUrl = null; //서명 파일Url
    },

    uploadChange: function(file, fileList) {
      console.log("uc");
      console.log(this.G_Img_File);
      console.log("fileList: ", fileList);
      this.G_Img_File.fileList = fileList;
      this.G_Img_File.fileList.forEach(file => {
        if (file.size > 50 * 1000 * 1000) {
          Message.error("50MB이상 파일은 업로드할 수 없습니다.");
          this.G_Img_File.fileList.splice(
            this.G_Img_File.fileList.indexOf(file),
            1
          );
          return;
        }
        const signFile = this.G_Img_File.fileList[0].raw; // Get first index in files
        this.imageUrl = URL.createObjectURL(signFile); // Create File
      });
    },
    // 선택한 파일 삭제
    removeFile: function(file, fileList) {
      console.log("rmFile");
      console.log(file);
      console.log(fileList);

      this.imageUrl = null;
      this.G_Img_File.fileList = fileList;
      // 삭제하는 파일의 raw 객체가 없다면, 그것은 이미 db에 존재하는 파일임. 이파일들의 id를 따로 모아서 파일삭제 api호출할 때 data로 집어넣음.
      if (file.raw === undefined) this.G_Img_File.removedIdArr.push(file.id); // DB에 존재하는 파일은 id가 존재함.
    },
    // 지정한 파일갯수를 초과해서 첨부했을 때
    exceedFileLimit: function() {
      Message.warning("파일첨부는 1개까지만 가능합니다.");
    },

    ToPage2() {
      let errMsg = [];

      if (this.leaseCheck == false || this.leaseCheck == null) {
        errMsg.push({
          message: "1페이지 상단 임대 체크박스를 확인해주세요.",
          ref: "leaseCheckBox"
          // IsfocusRequireEl: false,
          // pageNum: 1
        });
      }

      if (this.provideData == "0" || this.provideData == null) {
        errMsg.push({
          message: "1페이지 정보공개 여부를 확인해주세요.",
          ref: "provideDataSelect"
          // IsfocusRequireEl: false,
          // pageNum: 1
        });
      }

      if (errMsg.length == 0) {
        this.$emit("contractNum", 2);
        this.$emit("clientBirth", this.clientBirth);
        window.scrollTo(0, 420);
        return;
      }

      if (errMsg[0] != null) {
        // this.contractNum = errMsg[0].pageNum;
        this.$nextTick(() => {
          this.$refs[errMsg[0].ref].focus();
        });
        Message({
          message: errMsg[0].message,
          type: "error"
        });
      }

      if (errMsg[1] != null) {
        Message({
          message: errMsg[1].message,
          type: "error",
          offset: 60
        });
      }
    },
    SendContract1Data() {
      let Data = {
        leaseCheck: this.leaseCheck,
        provideData: this.provideData,
        brokCompenRate: this.brokCompenRate,
        brokCompenPrice: this.brokCompenPrice,
        clientAddr: this.clientAddr,
        clientName: this.clientName,
        clientTel: this.clientTel,
        imageUrl: this.imageUrl,
        clientBirth: this.clientBirth
      };
      this.$emit("SendContract1Data", Data);
    }
  }
};
</script>

<style></style>
